import React from 'react';

export const Input = React.forwardRef(function Input({ className = '', ...rest }, ref) {
  return (
    <input
      ref={ref}
      className={`flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...rest}
    />
  );
});

export default Input;
